import styled from "styled-components";

import { BoxSizingStyle } from "../BoxSizingStyle";
import { FontStyle } from "../FontStyle";

export const StyledWindow = styled.div`
  ${FontStyle}
  ${BoxSizingStyle}

  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;

StyledWindow.displayName = "StyledWindow";
